<template>
  <div class="aside-box" :style="{'width': width + 'px'}">
    <div class="aside-box-bd" :style="{'width': width + 'px'}">
      <logo></logo>
      <searchBox
      ref="searchBox"
      :pageType="2"
      :clickType="clickType"
      :hasSearch="hasSearch"
      @searchFun="searchFun"
      @projectChange="projectChange"></searchBox>
      <!-- <a-spin :spinning="spinning">
      <floorTab
      ref="floorTab"
      @setFloorId="setFloorId"></floorTab>
      </a-spin> -->
      <div v-if="floorList.length > 0" class="floor-desc">{{floorList[curFloorIndex].floorDesc}}</div>
      <businessList
      ref="businessList"
      :pageType="2"
      :hasSearch="hasSearch"
      @clickMerchant="clickMerchant"></businessList>
    </div>
    <div v-if="floorList.length > 1" class="floor-tab" :style="{'left': width + 'px'}">
      <div
      class="item"
      v-for="(item, index) in floorList"
      :key="item.id"
      :class="index === curFloorIndex ? 'cur' : ''"
      @click="changeFloorTab(item.id)">{{item.floorName}}</div>
    </div>
  </div>
</template>

<script>
import { getAction } from '@/api/http'
import logo from './logo'
import searchBox from './searchBox'
// import floorTab from './floorTab'
import businessList from './businessList'
export default {
  name: 'AsideBox',
  props: ['width'],
  components: {
    logo,
    searchBox,
    // floorTab,
    businessList
  },
  data () {
    return {
      spinning: false,
      clickType: 1, // 1代表点击城市项目地图左侧的商家进来  2表示点击城市项目地图的方块进来
      hasSearch: true,
      curFloorIndex: 0,
      floorList: [],
      curCityName: '',
      curProjectName: ''
    }
  },
  computed: {
    merchantId () {
      return this.$store.state.merchantId
    },
    cityId () {
      return this.$store.state.cityId
    },
    projectId () {
      return this.$store.state.projectId
    },
    floorId () {
      return this.$store.state.floorId
    }
  },
  mounted () {
    const that = this
    const merchantId = that.merchantId
    const cityId = that.cityId
    const projectId = that.projectId
    if (merchantId) {
      that.getMerchantInfo()
      that.clickType = 1
    } 
    if (cityId && projectId) {
      that.clickType = 2
      // that.$refs.floorTab.getFloor({
      //   cityId: cityId,
      //   projectId: projectId
      // })
      that.getFloor({
        cityId,
        projectId
      })
    }
  },
  methods: {
    // 切换项目
    projectChange () {
      const that = this
      const cityId = that.cityId
      const projectId = that.projectId
      // that.$refs.floorTab.getFloor({
      //   cityId,
      //   projectId
      // })
      that.getFloor({
        cityId,
        projectId
      })
    },

    // 根据城市项目楼层查询已认证商铺（用于在地图上用不同显示展示的功能）
    getAuthShop () {
      const that = this
      const cityId = that.cityId
      const projectId = that.projectId
      const floorId = that.floorId
      getAction('/shop/queryComList', {
        cityId,
        projectId,
        floorId
      }).then((res) => {
        if (res.code === '1') {
          const result = res.data || []
          that.$store.commit('setRoomInfoArry', result)
          that.reloadFloorMap()
        } else {
          that.$message.error(res.msg || '查询失败')
        }
      }).catch(() => {
        that.$message.error('查询失败')
      })
    },

    // 重新渲染楼层地图
    reloadFloorMap () {
      this.$emit('reloadFloorMap')
    },

    setFloorId () {
      const that = this
      that.getAuthShop()
      that.$refs.searchBox.searchShopInfo()
    },

    // 搜索
    searchFun () {
      const that = this
      that.reloadFloorMap()
      that.$nextTick(() => {
        that.$refs.businessList.getBusinessList()
      })
    },

    // 根据商家id获取项目和楼层相关信息
    getMerchantInfo () {
      const that = this
      const merchantId = that.merchantId
      that.spinning = true
      getAction('/shop/queryCompanyById', {
        id: merchantId
      }).then((res) => {
        if (res.code === '1') {
          const dataObj = res.data

          that.$store.commit('setCityId', dataObj.cityId)
          that.$store.commit('setProjectId', dataObj.subList[0].id)
          that.$store.commit('setFloorId', dataObj.houseList[0].floorId)
          that.$store.commit('setCityName', dataObj.cityName)
          that.$store.commit('setSearchKeyword', dataObj.companyName)
          
          that.$refs.searchBox.setPSearch(dataObj.subList)
          // that.$refs.floorTab.getFloor({
          //   cityId: that.cityId,
          //   projectId: that.projectId,
          //   floorId: that.floorId
          // })
          that.getFloor({
            cityId: that.cityId,
            projectId: that.projectId,
            floorId: that.floorId
          })
        } else {
          that.$message.error(res.msg || '查询失败')
        }
        that.spinning = false
      }).catch(() => {
        that.spinning = false
        that.$message.error('查询失败')
      })
    },

    // 点击商家
    clickMerchant () {
      this.$emit('clickMerchant')
    },

    // 切换楼层
    changeFloorTab (value) {
      const that = this
      const floorList = that.floorList
      for (let [index, item] of floorList.entries()) {
        if (value === item.id) {
          that.curFloorIndex = index
          that.$store.commit('setSvgUrl', that.$picUrl + item.filePath)
          that.$store.commit('setFloorId', item.id)
          that.$store.commit('setCityName', that.curCityName)
          that.$store.commit('setProjectName', that.curProjectName)
          that.setFloorId()
          that.$store.commit('setMerchantInfo', {
            isShowModal: false
          })
          that.$store.commit('setNoMerchant', {
            isShowModal: false
          })
        }
      }
    },

    // 获取楼层列表
    getFloor (options = {}) {
      const that = this
      const {
        floorId = '',
        cityId = '',
        projectId = ''
      } = options
      that.spinning = true
      getAction('/guide/room/sechRoom', {
        cityId: cityId,
        projectId: projectId
      }).then((res) => {
        that.spinning = false
        if (res.code === '1') {
          const dataObj = res.data
          that.floorList = dataObj.floorList || []
          that.curCityName = dataObj.cityName
          that.curProjectName = dataObj.projectName
          // 点击首页(城市项目地图)左侧的商家列表进来的时候
          if (floorId) {
            for (let [index, item] of that.floorList.entries()) {
              if (item.id == floorId) {
                that.curFloorIndex = index
                that.$store.commit('setSvgUrl', that.$picUrl + item.filePath)
                that.$store.commit('setFloorId', item.id)
                that.$store.commit('setCityName', dataObj.cityName)
                that.$store.commit('setProjectName', dataObj.projectName)
                that.setFloorId()
              }
            }
          } else { // 切换楼层平面图项目的时候
            if (that.floorList.length > 0) {
              that.curFloorIndex = 0
              that.$store.commit('setSvgUrl', that.$picUrl +  that.floorList[0].filePath)
              that.$store.commit('setFloorId', that.floorList[0].id)
              that.$store.commit('setCityName', dataObj.cityName)
              that.$store.commit('setProjectName', dataObj.projectName)
              that.setFloorId()
            } else {
              that.$message.info('正在建设中')
              setTimeout(function() {
                that.$router.push({
                  path: '/'
                })
              }, 3000)
            }
          }
        } else {
          that.$message.error(res.msg || '查询失败')
        }
      }).catch(() => {
        that.spinning = false
        that.$message.error('查询失败')
      })
    }
  }
}
</script>

<style>
.search-type .ant-radio-wrapper span.ant-radio + *{padding-left: 5px;padding-right: 5px;}
.search-bd .ant-input,.search-bd .ant-btn{height: 35px;}
.search-bd .ant-btn{font-size: 15px;}
.position .ant-btn{font-size: 12px;}
</style>
<style scoped>
/* .aside-box{position: absolute;left: 0;top: 0;bottom: 0;background-color: #f4f4f4;box-shadow: 8px 0 10px rgba(0,0,0,0.2);z-index: 1;overflow: hidden;} */
.aside-box{position: absolute;left: 0;top: 0;bottom: 0;}
.aside-box-bd{position: relative;height: 100%;background-color: #f4f4f4;box-shadow: 8px 0 10px rgba(0,0,0,0.2);z-index: 2;overflow: hidden;}
.logo{padding: 5px 0 8px;}

.search-type .ant-radio-wrapper{font-size: 12px;margin-right: 25px;}
.search-bd,.position{padding-left: 12px;padding-right: 12px;}
.search-bd{display: flex;margin-top: 3px;}
.search-ipt{margin-right: 5px;}
.position{display: flex;align-items: center;background-color: #eaeaea;padding-top: 5px;padding-bottom: 5px;margin-top: 10px;height: 34px;}
.position .bd{font-size: 12px;margin-left: 30px;}
.position .bd .jt{font-family: '宋体';color: #aaa;margin-left: 5px;margin-right: 5px;}
.position .bd .project{font-weight: bold;}

.floor-desc{background-color: #fff;text-align: left;padding: 12px;height: 94px;border-bottom: 1px solid #eaeaea;overflow: auto;font-size: 12px;}
.floor-tab{position: absolute;top: 129px;z-index: 1;background-color: #fff;font-size: 12px;color: #1c1f23;box-shadow: 8px 0 10px rgba(0,0,0,0.2);border-radius: 0 6px 6px 0;}
.floor-tab .item{width: 45px;padding-top: 8px;padding-bottom: 8px;}
.floor-tab .item:hover,.floor-tab .cur{background-color: #f7f9fa;cursor: pointer;border-radius: 0 6px 6px 0;color: #E94F5A;}
</style>